export default __webpack_public_path__ + "assets/googleRate.4ddc24e9.svg";